import React from 'react';
import styled from 'styled-components';
import Accordion from '../../misc/Accordion';

const StyledAccordionSettingsBody = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 12px;
  padding-top: 0px;
  box-sizing: border-box;
`;

/**
 * Simple style wrapper around internal
 * accordion component to keep consistent
 * look anywhere in styles.
 */
const AccordionSettings = (props) => {

  const { children } = props;

  return (
    <Accordion
      {...props}
      extraStyles={{ border: '0px solid transparent', borderBottom: '0px solid transparent', overflow: 'hidden', padding: '12px' }}
    >
      <StyledAccordionSettingsBody>
        {children}
      </StyledAccordionSettingsBody>
    </Accordion>
  );
};

export default AccordionSettings;
